import React from "react";

export const LazyContactsApiMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./ContactsApiMultiSelectAutoUpdate"
        )
);
